var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("strong", [
        _vm._v(_vm._s(_vm.$t("productQualityTests.measurement.measurements")))
      ]),
      _vm._v(" "),
      _c("MeasurementSpecificationsTemplateBadges", {
        attrs: { measurementSpecifications: _vm.rows.map(e => e.specification) }
      }),
      _vm._v(" "),
      _c("table", { staticClass: "table table-striped table-sm" }, [
        _c("thead", [
          _c("tr", [
            _c("th"),
            _vm._v(" "),
            _c("th", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "productQualityTests.measurementSpecification.model.name"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "text-right" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "productQualityTests.measurementSpecification.model.description"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "text-right" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "productQualityTests.measurementSpecification.model.lowerBound"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "text-right" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "productQualityTests.measurementSpecification.model.nominalValue"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "text-right" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "productQualityTests.measurementSpecification.model.upperBound"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "text-right" }, [
              _vm._v(
                _vm._s(_vm.$t("productQualityTests.measurement.model.value"))
              )
            ]),
            _vm._v(" "),
            _c(
              "th",
              [
                _vm.allowSeparateTesterInAnySpecification
                  ? [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "productQualityTests.measurement.model.testerName"
                            )
                          ) +
                          "\n          "
                      )
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c("th", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "productQualityTests.measurementSpecification.model.medias"
                  )
                )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            !_vm.rows.length
              ? _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: "9" } },
                    [
                      _c("CenterOnParent", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("general.noData")) +
                            "\n          "
                        )
                      ])
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.rows, function(row) {
              return _c("PqtMeasurementRow", {
                key: row.specification.id,
                attrs: {
                  specification: row.specification,
                  measurement: row.measurement,
                  attachments: row.attachments
                }
              })
            })
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }